import React, { Component } from "react";
import { Button, Spinner, Toast } from "react-bootstrap-v5";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { toast } from "react-toastify";

import SimpleReactValidator from "simple-react-validator";
import JobService from "../../../Services/JobService";
import { paymmentInformation } from "../../../Function/defaultJobOptions";

import QuickInfo from "./JobForms/QuickInfo";
import BookingParties, { RetailerAccount } from "./JobForms/BookingParties";
import Shipment from "./JobForms/Shipment";
import Schedule from "./JobForms/Schedule";
import Carrier from "./JobForms/Carrier";
import AddOns from "./JobForms/AddOns";
import Cargo from "./JobForms/Cargo";
import RevenueAndCost from "./JobForms/RevenueAndCost";
import QuoteBreakedown from "./JobForms/QuoteBreakedown";
import CostBreakdownSummary from "./JobForms/CostBreakdownSummary";
// import Cost from './JobForms/Cost'
import Documents from './JobForms/Documents'
import Retailer from './JobForms/Retailer'
import Loader from "../../../Components/Loader";
import CourierPartner from "./JobForms/CourierPartner";
// import CheckAccess from '../../../Function/CheckAccess';
// import Quotation from './Quotation'

const tabWidth = {
  width: "84%",
};

function withPackageDimensions(side) {
  if (!side) return side;
  const dim = side.dimension || {};
  return {
    ...side,
    length: side.length || dim.length || "",
    width: side.width || dim.width || "",
    height: side.height || dim.height || "",
    kilogram: side.kilogram || dim.kilogram || "",
  };
}

function cargoRowsFromProducts(products) {
  const rows = [];
  (products || []).forEach((product) => {
    const packages =
      Array.isArray(product.packages) && product.packages.length > 0
        ? product.packages
        : [];
    packages.forEach((pkg) => {
      const dim = pkg.dimension || {};
      const count = Number(pkg.count || pkg.no_of_pkgs || 1) || 1;
      const kilogram = Number(pkg.weight ?? pkg.kilogram ?? dim.kilogram ?? 0) || 0;
      const length = Number(pkg.length ?? dim.length ?? 0) || 0;
      const width = Number(pkg.width ?? dim.width ?? 0) || 0;
      const height = Number(pkg.height ?? dim.height ?? 0) || 0;
      const volume =
        Number(pkg.vol || pkg.total_volume_CBM) ||
        ((length * width * height) / 1000000) * count;
      const side = {
        item_description: product.productName || "Product",
        no_of_pkgs: count,
        kilogram,
        length,
        width,
        height,
        total_volume_CBM: Number(volume.toFixed(4)),
        total_weight_KG: Number((kilogram * count).toFixed(3)),
      };
      rows.push({ booking: { ...side }, actual: { ...side } });
    });
  });
  return rows;
}

class EditJobCart extends Component {
  constructor() {
    super();
    this.validator = new SimpleReactValidator();

    this.state = {
      buttonSubmit: true,
      validationToast: false,
      errorMsgs: [],
      jobData: {},
      removeBookingCount: 0,
      originData: {},
      destinationData: {},
      bookingAmount: 0,
      jobFinancialStatus: false,
      isDraftedInvoice: false,
      isDraftedCost: false,
      loading : false
    //   isview: null,
    };
  }

  componentDidMount() {
    //   const viewaccess = query.get("isedit");
    //   this.setState({ isEdit: viewaccess });
      this.setState({ loading : true })
      const query = new URLSearchParams(this.props.location.search);
      const jid = query.get("id");
      JobService.getJobDetails({ job_id: jid }).then((result) => {
      if (result.status === true) {
        let newStateData = result.data;
        let oData, dData;
        this.setState({
          jobFinancialStatus: result.data.is_financially_open,
        });

        //------ Set Origin and desination data for full address--------START---
        if (!newStateData.customer_details.mobile_number) {
          if (
            newStateData.user_detail &&
            newStateData.user_detail.length > 0 &&
            newStateData.user_detail[0].user_phone_number
          ) {
            newStateData.customer_details.mobile_number =
              newStateData.user_detail[0].user_phone_number;
          }
        }

        this.getPlaceData(newStateData.shipment_details.origin).then((e) => {
          oData = {
            origin_country: e.country,
            origin_country_short_name: e.country_short_name,
            origin_city: e.city,
            origin_latitude: e.latitude,
            origin_longitude: e.longitude,
          };
          this.setState(() => {
            return { originData: oData };
          });
        });

        this.getPlaceData(newStateData.shipment_details.destination).then(
          (e) => {
            dData = {
              origin_country: e.country,
              origin_country_short_name: e.country_short_name,
              origin_city: e.city,
              origin_latitude: e.latitude,
              origin_longitude: e.longitude,
            };

            this.setState(() => {
              return { destinationData: dData };
            });
          }
        );

        //------ Set Origin and desination data for full address--------END---
        
        if (!newStateData.buyer_details) newStateData.buyer_details = {};
        if (!newStateData.sender_details) newStateData.sender_details = {};
        if (!newStateData.sender_details.full_name) {
          newStateData.sender_details.full_name = newStateData.customer_details?.sipper || newStateData.customer_details?.name || "";
        }
        if (!newStateData.sender_details.contact_person && newStateData.customer_details?.sipper) {
          newStateData.sender_details.contact_person = newStateData.customer_details?.contact_person || newStateData.customer_details?.name || "";
        }
        if (!newStateData.sender_details.email) newStateData.sender_details.email = newStateData.customer_details?.email || "";
        if (!newStateData.sender_details.phone_number) newStateData.sender_details.phone_number = newStateData.customer_details?.mobile_number || "";
        if (!newStateData.sender_details.address) newStateData.sender_details.address = newStateData.customer_details?.address || "";
        if (!newStateData.receiver_details) newStateData.receiver_details = {};
        if (!newStateData.customer_details.shipper_country && newStateData.shipment_details.origin_country) {
          newStateData.customer_details.shipper_country = newStateData.shipment_details.origin_country;
        }
        if (!newStateData.customer_details.shipper_city && newStateData.shipment_details.origin) {
          newStateData.customer_details.shipper_city = newStateData.shipment_details.origin;
        }
        // Pre-fill Receiver info from shipment_details if missing
        if (!newStateData.receiver_details.country && newStateData.shipment_details.destination_country) {
          newStateData.receiver_details.country = newStateData.shipment_details.destination_country;
        }
        if (!newStateData.receiver_details.city && newStateData.shipment_details.destination) {
          newStateData.receiver_details.city = newStateData.shipment_details.destination;
        }

        const packageRows = cargoRowsFromProducts(newStateData.custom_products);
        const savedItems = Array.isArray(newStateData.quote_request_items)
          ? newStateData.quote_request_items
          : [];
        const savedHaveEachPackage =
          packageRows.length > 0 &&
          savedItems.length >= packageRows.length &&
          savedItems.every((row) => Number(row?.booking?.length) || Number(row?.booking?.width) || Number(row?.booking?.height));
        if (packageRows.length > 0 && !savedHaveEachPackage) {
          newStateData.quote_request_items = packageRows;
        } else if (savedItems.length > 0) {
          newStateData.quote_request_items = savedItems.map((row) => ({
            ...row,
            booking: withPackageDimensions(row.booking),
            actual: withPackageDimensions(row.actual || row.booking),
          }));
        }

        if (!newStateData.hasOwnProperty("carrier_details")) {
          newStateData.carrier_details = {
            m_awb_m_b_l: "",
            m_awb_h_b_l: "",
            carrier_name: "",
            port_of_entry: "",
            shipment_type: "",
            comments: "",
          };
        }

        if (!newStateData.hasOwnProperty("payment_information")) {
          newStateData.payment_information = paymmentInformation();
        }

        if (!newStateData.hasOwnProperty("schedule_pickup")) {
          newStateData.schedule_pickup = {
            comments: "",
            pickup: [
              {
                pickup_shipment: "",
                salutation: "",
                sender_name: "",
                pickup_contact: "",
                pickup_date: "",
                pickup_time: "",
                address: "",
                email: "",
                delevered_by: "",
                invoice_no: "",
              },
            ],
          };
        }

        if (!newStateData.hasOwnProperty("document")) {
          newStateData.document = {
            customer_document: [
              {
                document_name: "",
                document_type: "",
                document: "",
                document_file: [],
              },
            ],
            store_document: [
              {
                document_name: "",
                document_type: "",
                document: "",
                document_file: [],
              },
            ],
          };
        }

        if (
          !newStateData.hasOwnProperty("retailer_details") ||
          Object.keys(newStateData.retailer_details).length === 0
        ) {
          newStateData.retailer_details = [];
        }

        if (!newStateData.quote_request_items || newStateData.quote_request_items.length === 0) {
          if (newStateData.custom_products && newStateData.custom_products.length > 0) {
            let mappedItems = [];
            newStateData.custom_products.forEach(product => {
              if (product.packages && product.packages.length > 0) {
                product.packages.forEach(pkg => {
                  mappedItems.push({
                    booking: {
                      no_of_pkgs: pkg.count || 1,
                      item_description: product.productName || "Product",
                      length: pkg.length || 0,
                      width: pkg.width || 0,
                      height: pkg.height || 0,
                      kilogram: pkg.weight || 0,
                      total_volume_CBM: pkg.vol || 0,
                      total_weight_KG: (pkg.weight || 0) * (pkg.count || 1)
                    },
                    actual: {
                      no_of_pkgs: pkg.count || 1,
                      item_description: product.productName || "Product",
                      length: pkg.length || 0,
                      width: pkg.width || 0,
                      height: pkg.height || 0,
                      kilogram: pkg.weight || 0,
                      total_volume_CBM: pkg.vol || 0,
                      total_weight_KG: (pkg.weight || 0) * (pkg.count || 1)
                    }
                  });
                });
              } else {
                mappedItems.push({
                  booking: {
                    no_of_pkgs: product.quantity || 1,
                    item_description: product.productName || "Product",
                    length: "",
                    width: "",
                    height: "",
                    kilogram: "",
                    total_volume_CBM: "",
                    total_weight_KG: ""
                  },
                  actual: {
                    no_of_pkgs: product.quantity || 1,
                    item_description: product.productName || "Product",
                    length: "",
                    width: "",
                    height: "",
                    kilogram: "",
                    total_volume_CBM: "",
                    total_weight_KG: ""
                  }
                });
              }
            });
            newStateData.quote_request_items = mappedItems;
          } else {
            newStateData.quote_request_items = [];
          }
        } else if (newStateData.quote_request_items && newStateData.quote_request_items.length > 0) {
          newStateData.quote_request_items.forEach(item => {
            if (item.actual) {
              if (Number(item.actual.no_of_pkgs) === 0 || item.actual.no_of_pkgs === "") item.actual.no_of_pkgs = "";
              if (!item.actual.item_description || item.actual.item_description === "") item.actual.item_description = "";
              if (Number(item.actual.length) === 0 || item.actual.length === "") item.actual.length = "";
              if (Number(item.actual.width) === 0 || item.actual.width === "") item.actual.width = "";
              if (Number(item.actual.height) === 0 || item.actual.height === "") item.actual.height = "";
              if (Number(item.actual.kilogram) === 0 || item.actual.kilogram === "") item.actual.kilogram = "";
              if (Number(item.actual.total_volume_CBM) === 0 || item.actual.total_volume_CBM === "") item.actual.total_volume_CBM = "";
              if (Number(item.actual.total_weight_KG) === 0 || item.actual.total_weight_KG === "") item.actual.total_weight_KG = "";
            } else {
              item.actual = {
                no_of_pkgs: "",
                item_description: "",
                length: "",
                width: "",
                height: "",
                kilogram: "",
                total_volume_CBM: "",
                total_weight_KG: ""
              };
            }
          });
        }

        this.setState(
          {
            jobData: newStateData,
            removeBookingCount: newStateData.quote_request_items.length,
            loading : false
          },
          () => {
            this.setBookingAmount();
          }
        );
      }
    });
  }

  setBookingAmount = () => {
    const {
      quote_request_airs,
      quote_request_couriers,
      quote_request_lands,
      quote_request_seas,
      shipment_details,
      payment_information,
    } = this.state.jobData;

    if (
      Object.keys(quote_request_airs).length === 0 &&
      Object.keys(quote_request_couriers).length === 0 &&
      Object.keys(quote_request_lands).length === 0 &&
      Object.keys(quote_request_seas).length === 0
    ) {
      this.setState({ bookingAmount: payment_information.booking_amount });
      return false;
    }

    let getFinalQuotezKey;

    let sType = shipment_details.hasOwnProperty("servic_type")
      ? shipment_details.servic_type
      : shipment_details.service_type;

    if (sType.includes("PORT")) getFinalQuotezKey = "port_delivery";
    if (sType.includes("DOOR")) getFinalQuotezKey = "door_delivery";
    if (sType.includes("CONSOLIDATION"))
      getFinalQuotezKey = "consolidation_delivery";
    if (sType.includes("OTHER")) getFinalQuotezKey = 'other_delivery'

    let bAmt = 0;
    let k = getFinalQuotezKey?.replace("_delivery", "");

    if (sType.includes("AIR")) {
      bAmt =
        quote_request_airs?.final[getFinalQuotezKey][
          `discount_${k}_grant_total`
        ];
    } else if (sType.includes("COURIER")) {
      bAmt =
        quote_request_couriers?.final.door_delivery?.discount_door_grant_total;
    } else if (sType.includes("SEA")) {
      bAmt =
        quote_request_seas?.final[getFinalQuotezKey] &&
        quote_request_seas?.final[getFinalQuotezKey][
          `discount_${k}_grant_total`
        ];
    } else if (sType.includes("LAND")) {
      bAmt =
        quote_request_lands?.final[getFinalQuotezKey][
          `discount_${k}_grant_total`
        ];
    }

    this.setState({ bookingAmount: bAmt });
  };

  handleChangeValue = (event, objKey, objInnerKey = "") => {
    let fieldKey = objInnerKey != "" ? objInnerKey : event.target.name;
    let fieldValue =
      event.value == undefined ? event.target.value : event.value;
    let jobCardData = this.state.jobData;

    if (
      fieldKey === "quote_request_items" ||
      fieldKey === "retailer_details" ||
      fieldKey === "is_job_open" ||
      fieldKey === "general_details" ||
      fieldKey === "deliverer" ||
      fieldKey === "job_status"
    ) {
      jobCardData[objKey] = fieldValue;
      this.setState(jobCardData);
    } else if (fieldKey === "insurance" || fieldKey === "storage") {
      jobCardData[objKey][fieldKey][event.name] = fieldValue;
      this.setState(jobCardData);
    } else {
      jobCardData[objKey][fieldKey] = fieldValue;
      if(fieldKey == 'insurance_opted' && fieldValue == 'no'){
       delete jobCardData[objKey]['insurance_applied'];
       delete jobCardData[objKey]['insurance_policy_received'] ;
      }else if(fieldKey == 'insurance_applied' && fieldValue == 'no'){
        delete jobCardData[objKey]['insurance_policy_received'] ;
      }
    }
    this.setState(jobCardData);
  };


  // handleSelect = (event, objKey, objInnerKey, index = null) => {
  //   console.log(event, "event");
  //   console.log(objKey, "objKey");
  //   console.log(objInnerKey, "objInnerKey");
  //   console.log(index, "index");
  
  //   let fieldKey = objInnerKey ? objInnerKey : event.target.name;
  //   let fieldValue = event.value !== undefined ? event.value : event.target.value;
  
  //   this.setState((prevState) => {
  //     let jobCardData = { ...prevState.jobData }; // Copy state to avoid mutation
  
  //     if (fieldKey === "shpt_receipt_assorment") {
  //       if (index !== null) {
  //         console.log(jobCardData[objKey], "jobCardData")
  //         jobCardData[objKey] = [...jobCardData[objKey]]; // Copy array
  //         jobCardData[objKey][index] = {
  //           ...jobCardData[objKey][index],
  //           [fieldKey]: fieldValue,
  //         };
  //       }
  //     } else if (fieldKey === "insurance" || fieldKey === "storage") {
  //       jobCardData[objKey] = { ...jobCardData[objKey] }; // Copy object
  //       jobCardData[objKey][fieldKey] = {
  //         ...jobCardData[objKey][fieldKey],
  //         [event.name]: fieldValue,
  //       };
  //     } else {
  //       jobCardData[objKey] = { ...jobCardData[objKey] }; // Copy object
  //       jobCardData[objKey][fieldKey] = fieldValue;
  
  //       if (fieldKey === "insurance_opted" && fieldValue === "no") {
  //         delete jobCardData[objKey]["insurance_applied"];
  //         delete jobCardData[objKey]["insurance_policy_received"];
  //       } else if (fieldKey === "insurance_applied" && fieldValue === "no") {
  //         delete jobCardData[objKey]["insurance_policy_received"];
  //       }
  //     }
  
  //     return { jobData: jobCardData }; // Return updated state
  //   });
  // };
  

  handleSelect = (event, objKey, objInnerKey, index = null) => {
  
    const fieldKey = objInnerKey || event.target?.name;
    const fieldValue = event?.value !== undefined ? event.value : event.target?.value;
  
    this.setState((prevState) => {
      const jobCardData = { ...prevState.jobData };
  
      if (fieldKey === "shpt_receipt_assorment" && index !== null) {
        // Target: jobCardData[objKey].pickup[index][fieldKey]
        const existingSection = { ...(jobCardData[objKey] || {}) };
        const pickupArray = [...(existingSection.pickup || [])];
  
        pickupArray[index] = {
          ...pickupArray[index],
          [fieldKey]: fieldValue,
        };
  
        jobCardData[objKey] = {
          ...existingSection,
          pickup: pickupArray,
        };
      } else if (fieldKey === "insurance" || fieldKey === "storage") {
        jobCardData[objKey] = {
          ...jobCardData[objKey],
          [fieldKey]: {
            ...(jobCardData[objKey]?.[fieldKey] || {}),
            [event.name]: fieldValue,
          },
        };
      } else {
        jobCardData[objKey] = {
          ...jobCardData[objKey],
          [fieldKey]: fieldValue,
        };
  
        if (fieldKey === "insurance_opted" && fieldValue === "no") {
          delete jobCardData[objKey]["insurance_applied"];
          delete jobCardData[objKey]["insurance_policy_received"];
        } else if (fieldKey === "insurance_applied" && fieldValue === "no") {
          delete jobCardData[objKey]["insurance_policy_received"];
        }
      }
  
      return { jobData: jobCardData };
    });
  };
  
  
  
  
  
  

  resetAddOnPayment = () => {
    let jobCardData = this.state.jobData;
    jobCardData.payment_information = paymmentInformation();
    jobCardData.add_ons.insurance = {
      insurance_amount: 0,
      insurance_premium: 0,
      items_goods: 0,
      minimum_aed: 0,
    };

    jobCardData.add_ons.storage = {
      handling_in: 0,
      handling_out: 0,
      minimum: 0,
      storage_amount: 0,
      storage_charges: 0,
      storage_value: 0,
    };
    this.setState(jobCardData);
  };

  getPlaceData = (address) => {
    return geocodeByAddress(address).then((results) => {
      const contrypick = results[0].address_components.filter(
        (item) => item.types.indexOf("country") >= 0
      );
      const citypick = results[0].address_components.filter(
        (item) =>
          item.types.indexOf("locality") >= 0 ||
          item.types.indexOf("administrative_area_level_1") >= 0
      );

      return getLatLng(results[0]).then((latlngRes) => {
        let pl = {
          country: contrypick[0]?.long_name,
          country_short_name: contrypick[0].short_name,
          city: citypick[0]?.long_name,
          latitude: latlngRes.lat,
          longitude: latlngRes.lng,
        };

        return pl;
      });
    });
  };

  handleChangeOriginDestination = (type, data) => {
    this.setState({ [type]: data });
  };

  handleOringDestination = (e, objKey) => {
    let jobCardData = this.state.jobData;
    jobCardData[objKey] = { ...jobCardData[objKey], ...e };
    this.setState(jobCardData);
  };

  validateCargoFields = (paramdata) => {
    let invalidFields = paramdata.filter((item1) => {
      const isActualEmpty =
        (!item1.actual.no_of_pkgs || Number(item1.actual.no_of_pkgs) === 0) &&
        (!item1.actual.item_description || item1.actual.item_description.trim() === "") &&
        (!item1.actual.height || Number(item1.actual.height) === 0) &&
        (!item1.actual.width || Number(item1.actual.width) === 0) &&
        (!item1.actual.length || Number(item1.actual.length) === 0) &&
        (!item1.actual.kilogram || Number(item1.actual.kilogram) === 0);

      const isBookingEmpty =
        (!item1.booking.no_of_pkgs || Number(item1.booking.no_of_pkgs) === 0) &&
        (!item1.booking.item_description || item1.booking.item_description.trim() === "") &&
        (!item1.booking.height || Number(item1.booking.height) === 0) &&
        (!item1.booking.width || Number(item1.booking.width) === 0) &&
        (!item1.booking.length || Number(item1.booking.length) === 0) &&
        (!item1.booking.kilogram || Number(item1.booking.kilogram) === 0);

      // If both are completely empty, it's not invalid (just an empty row)
      if (isActualEmpty && isBookingEmpty) {
        return false;
      }

      // Otherwise, it's invalid if any required field is missing in actual OR booking
      return (
        Number(item1.actual.no_of_pkgs) === 0 ||
        item1.actual.no_of_pkgs === "" ||
        !item1.actual.item_description ||
        item1.actual.item_description.trim() === "" ||
        Number(item1.actual.height) === 0 ||
        item1.actual.height === "" ||
        Number(item1.actual.width) === 0 ||
        item1.actual.width === "" ||
        Number(item1.actual.length) === 0 ||
        item1.actual.length === "" ||
        Number(item1.actual.kilogram) === 0 ||
        item1.actual.kilogram === "" ||
        Number(item1.booking.no_of_pkgs) === 0 ||
        item1.booking.no_of_pkgs === "" ||
        !item1.booking.item_description ||
        item1.booking.item_description.trim() === "" ||
        Number(item1.booking.height) === 0 ||
        item1.booking.height === "" ||
        Number(item1.booking.width) === 0 ||
        item1.booking.width === "" ||
        Number(item1.booking.length) === 0 ||
        item1.booking.length === "" ||
        Number(item1.booking.kilogram) === 0 ||
        item1.booking.kilogram === ""
      );
    });

    return invalidFields.length > 0;
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.setState({ buttonSubmit: false });
    if (this.validator.allValid()) {
      let postData = this.state.jobData;
      postData.receiver_details.consignee =
        postData.receiver_details.receiver_name;
      postData.job_id = this.state.jobData._id;
      // if (this.validateCargoFields(postData.quote_request_items)) {
      //   toast.error("Please fill cargo required fields");
      //   this.setState({ buttonSubmit: true });
      //   return false;
      // }
      JobService.updateJobservice(postData).then((result) => {
        if (result.status === true) {
          toast.success(result.message);
          this.props.history.push("/job-list");
        }
      });
      this.setState({ buttonSubmit: true });
    } else {
      this.setState({ validationToast: true });
      this.validator.showMessages();
      // rerender to show messages for the first time
      // you can use the autoForceUpdate option to do this automatically`
      this.forceUpdate();
      this.setState({ buttonSubmit: true });
    }
  };

  closeFinancially = async () => {
      let payload = {
      status: false,
      job_token: this.state.jobData.job_token,
    };
    await JobService.closeFinancialStatus(payload)
      .then((res) => {
        if (res.status === true) {
          toast.success(res.message);
          this.props.history.push("/job-list");
        } else {
          toast.error(res.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  render() {
    const { jobData, buttonSubmit, validationToast, errorMsgs, loading } = this.state;
    if (!jobData || Object.keys(jobData).length === 0) return false;

    return (
      <>
        <form className="control-form" onSubmit={this.onSubmit}>
        <Loader isShow={this.state.loading}  />
          <QuickInfo
            onChangeValue={this.handleChangeValue}
            jobId={jobData._id}
            jobCustData={jobData.customer_details}
            jobShipmentData={jobData.shipment_details}
            jobToken={jobData.job_token}
            isJobOpen={jobData.is_job_open}
            paymentInformation={jobData.payment_information}
            generalDetails={jobData.general_details}
            userDetails={jobData.user_detail}
            jobData={jobData}
            formValidator={this.validator}
            stateData={this.state}
          />

          <div className="d-flex align-items-start">
            <div
              className="nav flex-column nav-pills me-3 bg-white"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <button
                className="nav-link active"
                id="v-pills-home-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-home"
                type="button"
                role="tab"
                aria-selected="true"
              >
                Retailer Info
              </button>

              <button
                className="nav-link"
                id="v-pills-profile-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-profile"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Buyer, Sender & Receiver
              </button>

              <button
                className="nav-link"
                id="v-pills-shipment-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-shipment"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Shipment Summary
              </button>

              <button
                className="nav-link"
                id="v-pills-cargo-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-cargo"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Cargo Details
              </button>

              <button
                className="nav-link"
                id="v-pills-addons-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-addons"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Add Ons
              </button>

              <button
                className="nav-link"
                id="v-pills-schedule-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-schedule"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Schedule Pickup
              </button>

              <button
                className="nav-link"
                id="v-pills-carrier-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-carrier"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Carrier Details
              </button>

              <button
                className="nav-link"
                id="v-pills-revenue-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-revenue"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Revenue And Cost
              </button>

              {/* <button className="nav-link" id="v-pills-cost-tab" data-bs-toggle="pill" data-bs-target="#v-pills-cost" type="button" role="tab" aria-selected="false">Cost</button> */}

              <button
                className="nav-link"
                id="v-pills-document-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-document"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Documents
              </button>

              <button
                className="nav-link"
                id="v-pills-retailer-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-retailer"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Retailer
              </button>
              <button
                className="nav-link"
                id="v-pills-quote-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-quote"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Amount breakdown
              </button>
              {jobData.added_by.quote_by === "MARKETPLACE" && 
                <button
                  className="nav-link"
                  id="v-pills-quote-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-courier-partner"
                  type="button"
                  role="tab"
                  aria-selected="false"
                >
                  Courier Partners
                </button>
              }
            </div>

            <div
              className="tab-content"
              id="v-pills-tabContent"
              style={tabWidth}
            >
              <div
                className="tab-pane fade show active"
                id="v-pills-home"
                role="tabpanel"
                aria-labelledby="v-pills-home-tab"
              >
                <RetailerAccount jobData={jobData} />
              </div>

              <div
                className="tab-pane fade"
                id="v-pills-profile"
                role="tabpanel"
                aria-labelledby="v-pills-profile-tab"
              >
                <BookingParties jobData={jobData} onChangeValue={this.handleChangeValue} />
              </div>

              <div
                className="tab-pane fade"
                id="v-pills-shipment"
                role="tabpanel"
                aria-labelledby="v-pills-shipment-tab"
              >
                <Shipment
                  onChangeValue={this.handleChangeValue}
                  handleResetAddOnPayment={this.resetAddOnPayment}
                  jobData={jobData.shipment_details}
                  jobItems={jobData.quote_request_items}
                  quoteToken={jobData.quote_token}
                  paymentInformation={jobData.payment_information}
                  handleChangeOrgDest={this.handleChangeOriginDestination}
                  formValidator={this.validator}
                  handleOringDestination={this.handleOringDestination}
                  isview={this.state.isview}
                  handleSelect={this.handleSelect}
                  schedulePickup={jobData.schedule_pickup}
                  orderId={jobData?.mk_order_id}
                />
              </div>

              <div
                className="tab-pane fade"
                id="v-pills-schedule"
                role="tabpanel"
                aria-labelledby="v-pills-schedule-tab"
              >
                <Schedule
                  isview={this.state.isview}
                  onChangeValue={this.handleChangeValue}
                  jobData={jobData.schedule_pickup}
                  totalJobData={jobData}
                  jobToken={jobData.job_token}
                  quoteToken={jobData.quote_token}
                  formValidator={this.validator}
                />
              </div>

              <div
                className="tab-pane fade"
                id="v-pills-carrier"
                role="tabpanel"
                aria-labelledby="v-pills-carrier-tab"
              >
                <Carrier
                  onChangeValue={this.handleChangeValue}
                  jobData={jobData.carrier_details}
                  formValidator={this.validator}
                />
              </div>

              <div
                className="tab-pane fade"
                id="v-pills-addons"
                role="tabpanel"
                aria-labelledby="v-pills-addons-tab"
              >
                <AddOns
                  onChangeValue={this.handleChangeValue}
                  jobData={jobData.quote_request_items}
                  addOns={jobData.add_ons}
                  jobCargoData={jobData.cargo_details}
                  jobShipmentData={jobData.shipment_details}
                  generalDetails={jobData.general_details}
                  quoteToken={jobData.quote_token}
                  originData={this.state.originData}
                  destinationData={this.state.destinationData}
                  paymentInformation={jobData.payment_information}
                  prevItemCount={this.state.removeBookingCount}
                  itemsBookingAmount={this.state.bookingAmount}
                  formValidator={this.validator}
                />
              </div>

              <div
                className="tab-pane fade"
                id="v-pills-cargo"
                role="tabpanel"
                aria-labelledby="v-pills-cargo-tab"
              >
                <Cargo
                  onChangeValue={this.handleChangeValue}
                  jobData={jobData.quote_request_items}
                  customProducts={jobData.custom_products}
                  removeBookingCount={this.state.removeBookingCount}
                  jobShipmentData={jobData.shipment_details}
                  jobCargoData={jobData.cargo_details}
                  quoteToken={jobData.quote_token}
                  originData={this.state.originData}
                  destinationData={this.state.destinationData}
                  paymentInformation={jobData.payment_information}
                  formValidator={this.validator}
                  isEdit={this.state.isEdit}
                />
              </div>

              <div
                className="tab-pane fade"
                id="v-pills-revenue"
                role="tabpanel"
                aria-labelledby="v-pills-revenue-tab"
              >
                <RevenueAndCost
                  // isInvoice={this.state.isInvoice}
                //   isEdit={this.state.isEdit}
                  checkInvoice={(draft) => {
                    this.setState({
                      isDraftedInvoice: draft,
                    });
                  }}
                  checkCost={(draft) => {
                    this.setState({
                      isDraftedCost: draft,
                    });
                  }}
                  onChangeValue={this.handleChangeValue}
                  jobData={jobData.retailer_details}
                  bookingData={jobData}
                  jobStatus={jobData.job_status}
                  customerData={jobData.customer_details}
                  receiverData={jobData.receiver_details}
                  quoteToken={jobData.job_token}
                  carrierData={jobData.carrier_details}
                  payInfoData={jobData.payment_information}
                  jobId={jobData._id}
                  jobToken={jobData.job_token}
                  formValidator={this.validator}
                />
              </div>

              {/* <div className="tab-pane fade" id="v-pills-cost" role="tabpanel" aria-labelledby="v-pills-cost-tab">
                                <Cost 
                                    onChangeValue={this.handleChangeValue}
                                    jobData={jobData.retailer_details}
                                    customerData={jobData.customer_details}
                                    jobId={jobData._id}
                                    formValidator={this.validator} 
                                />
                            </div> */}

              <div
                className="tab-pane fade"
                id="v-pills-document"
                role="tabpanel"
                aria-labelledby="v-pills-document-tab"
              >
                <Documents
                  onChangeValue={this.handleChangeValue}
                  jobData={jobData}
                  formValidator={this.validator}
                />
              </div>

              <div
                className="tab-pane fade"
                id="v-pills-retailer"
                role="tabpanel"
                aria-labelledby="v-pills-retailer-tab"
              >
                <Retailer
                //   isview={this.state.isview}
                  onChangeValue={this.handleChangeValue}
                  // jobData={jobData.retailer_details}
                  jobId={jobData._id}
                  formValidator={this.validator}
                />
              </div>

              <div
                className="tab-pane fade"
                id="v-pills-quote"
                role="tabpanel"
                aria-labelledby="v-pills-quote-tab"
              >
                <div style={{ marginBottom: "20px" }}>
                  <CostBreakdownSummary jobData={jobData} />
                </div>
                <QuoteBreakedown
                //   isview={this.state.isview}
                  // onChangeValue={this.handleChangeValue}
                  jobData={jobData}
                  shipmentDetails={jobData.shipment_details}
                  // formValidator={this.validator}
                />
              </div>

                {jobData.added_by.quote_by === "MARKETPLACE" && 
                <div
                  className="tab-pane fade"
                  id="v-pills-courier-partner"
                  role="tabpanel"
                  aria-labelledby="v-pills-quote-tab"
                >
                  <CourierPartner
                    jobData={jobData}
                    itemList={jobData.quote_request_items}
                    pickupList={jobData.schedule_pickup.pickup}
                    job_token={jobData.job_token}
                    receiver_details={jobData.receiver_details}
                    disabled={false}
                  />
                </div>
                }
            </div>
          </div>

          {/* {this.state.isview && ( */}
            <div className="row">
              <div className="col-2"></div>
              <div className="col-4">
                {buttonSubmit && (
                  <Button type="submit" variant="primary" size="lg">
                    Submit
                  </Button>
                )}

                {!buttonSubmit && (
                  <Button variant="primary" disabled>
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    Loading...
                  </Button>
                )}

                {
                  <Toast
                    className="d-inline-block m-1 bg-danger"
                    onClose={() => this.setState({ validationToast: false })}
                    show={validationToast} /* delay={3000} */
                  >
                    <Toast.Header>
                      <strong className="me-auto">Errors</strong>
                    </Toast.Header>
                    <Toast.Body className="text-white">
                      {Object.keys(this.validator.getErrorMessages()).map(
                        (key,i) => {
                          return (
                            <p key={i}>{this.validator.getErrorMessages()[key]}</p>
                          );
                        }
                      )}
                    </Toast.Body>
                  </Toast>
                }
              </div>
              {this.state.jobFinancialStatus &&
                !this.state.isDraftedInvoice &&
                !this.state.isDraftedCost && (
                  <div className="col-5 d-flex justify-content-end">
                    <Button type="button" variant="primary" size="lg" onClick={this.closeFinancially} >
                      Close Financially
                    </Button>
                  </div>
                )}

              {/* <div className="col-6"> */}
              {/* <Quotation
                                jobItems={jobData.quote_request_items}
                                jobShipmentData={jobData.shipment_details}
                                jobCargoData={jobData.cargo_details}
                                quoteToken={jobData.quote_token}
                                originData={this.state.originData}
                                destinationData={this.state.destinationData}
                            /> */}
              {/* </div> */}
            </div>
          {/* )} */}
        </form>
      </>
    );
  }
}

export { EditJobCart };

